import { render, staticRenderFns } from "./CategoryNode.vue?vue&type=template&id=d35d6570&"
import script from "./CategoryNode.vue?vue&type=script&lang=js&"
export * from "./CategoryNode.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNode.vue?vue&type=style&index=0&id=d35d6570&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports